import { useCallback, useMemo } from 'react';
import { PlanStatuses } from '@common-fe/common-fe';

import { useGetPlanTerminationPropertiesQuery } from '../PlanTerminationModalForms/queries/useGetPlanTerminationProperties.query';
import { usePlanTerminationBannerStore } from '../store';

const usePlanTerminationBanner = () => {
  const planId = usePlanTerminationBannerStore((state) => state.planId);
  const planName = usePlanTerminationBannerStore((state) => state.planName);
  const terminationStatus = usePlanTerminationBannerStore((state) => state.terminationStatus);
  const isHsaAccount = usePlanTerminationBannerStore((state) => state.isHsaAccount);

  const handleSetPlanId = usePlanTerminationBannerStore((state) => state.handleSetPlanId);
  const handleSetPlanName = usePlanTerminationBannerStore((state) => state.handleSetPlanName);
  const handleSetIsHsaAccount = usePlanTerminationBannerStore((state) => state.handleSetIsHsaAccount);
  const handleSetTerminationStatus = usePlanTerminationBannerStore((state) => state.handleSetTerminationStatus);

  const handleSetPlanTerminationDetails = useCallback(
    (id: string, name?: string, isHsa?: boolean, status?: string) => {
      handleSetPlanName(name);
      handleSetPlanId(id ? `${id}` : undefined);
      handleSetIsHsaAccount(isHsa);
      handleSetTerminationStatus(status);
    },
    [
      handleSetPlanName,
      handleSetPlanId,
      handleSetIsHsaAccount,
      handleSetTerminationStatus,
    ],
  );

  const isPlanPendingTermination = useMemo(() => {
    return terminationStatus && (terminationStatus === PlanStatuses.PENDING_TERMINATION);
  }, [terminationStatus]);
  const isTerminated = useMemo(() => {
    return terminationStatus
    && (terminationStatus === PlanStatuses.TERMINATED || terminationStatus === PlanStatuses.TERMINATION_IN_PROGRESS);
  }, [terminationStatus]);

    const isTerminationDataCanBeLoaded = useMemo(() => {
    return isPlanPendingTermination || isTerminated;
  }, [isPlanPendingTermination, isTerminated]);

  const {
    formattedData,
    isLoading: terminationDataLoading
  } = useGetPlanTerminationPropertiesQuery(isTerminationDataCanBeLoaded ? planId || '' : undefined);

  const showBanner = useMemo(() => {
    return (isPlanPendingTermination || isTerminated) && !terminationDataLoading && !!formattedData?.terminationDate;
  }, [isPlanPendingTermination, isTerminated, terminationDataLoading, formattedData?.terminationDate]);

  const bannerHeight: string | undefined = useMemo(() => showBanner ? '56px' : undefined, [showBanner]);
    
  return {
    terminationStatus,
    showBanner,
    bannerHeight,
    planName,
    terminationDate: formattedData?.terminationDate,
    planId,
    isHsaAccount,
    isTerminated,
    handleSetPlanTerminationDetails,
    planStatus: terminationStatus,
  };
};

export default usePlanTerminationBanner;
